module.exports = __webpack_public_path__ + "static/img/print-4.a838a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print-4.png
// module id = TmRr
// module chunks = 10